import { SpotLight, Stars } from "@react-three/drei";
import React from "react";
import { Color } from "three";

const Lighting = () => {
  return (
    <>
      <Stars />
      <ambientLight intensity={0.8} />
      {/* <SpotLight
        penumbra={0.5}
        // depthBuffer={depthBuffer}
        position={[3, 2,0]}
        intensity={0.2}
        angle={0.5}
        color="#ff005b"
        castShadow
      /> */}
      <spotLight
        color={[1, 0.25, 0.7]}
        intensity={1.5}
        angle={0.6}
        penumbra={0.5}
        position={[5, 5, 0]}
        castShadow
      />
      <directionalLight
        position={[2, 3, 3]}
        color={"gold"}
        intensity={0.5}
        angle={0.6}
        penumbra={0.5}
        castShadow
      />
      <directionalLight
        position={[-2, 3, 3]}
        color={"gold"}
        intensity={1.5}
        angle={0.6}
        penumbra={0.5}
        castShadow
      />
      <spotLight
        color={[0.14, 0.5, 1]}
        intensity={2}
        angle={0.6}
        penumbra={0.5}
        position={[-5, 5, 0]}
        castShadow
      />
      <spotLight
        color={[0.7, 0.25, 0.4]}
        intensity={1.5}
        angle={0.6}
        penumbra={0.5}
        position={[5, -5, 5]}
        castShadow
      />
      <spotLight
        color={[0.5, 0.14, 0.4]}
        intensity={1.5}
        angle={0.6}
        penumbra={0.5}
        position={[3, 3, -5]}
        castShadow
      />
    </>
  );
};

export default Lighting;
